import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroPipe } from '../pipes/filtro.pipe';

import { ProfissionalService } from '../services/profissional.service';
import { AuthService } from '../services/auth.service';
import { ExcelService } from '../services/excel.service';
import * as moment from 'moment';


@Component({
  selector: 'app-relatorio-condutores',
  templateUrl: './relatorio-condutores.component.html',
  styleUrls: ['./relatorio-condutores.component.css'],
	animations: [loadingFade, modal, alert]
})
export class RelatorioCondutoresComponent implements OnInit {
  public loading = false;

  // paginacao
	public page = 1;
	public limit = 10;
  public count = 0;

  // alert
	public msg_alerta = '';
	public class_alerta = '';
	public flag_alerta = 'hidden';

  // filtro
	public filtro = [];
	public dadosFiltrados = [];
	public filtered = false;
	public formFiltro: FormGroup;
	public showFilter = true;
  public profissionais = [];
  
  constructor(private authSvc: AuthService,
              private profissionalSvc: ProfissionalService,
              private excelSvc: ExcelService) { }

  ngOnInit() {
    this.pegaCondutores(this.authSvc.getUsuarioId());

  }

  pegaCondutores(usuario_id){
    this.profissionalSvc.getRelatorioCondutores(usuario_id).then((data: any) => {
			this.profissionais = data;
      this.count = data.length;
    }).catch((err) => console.log(err));
  }

  primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
  }
  
  exportarExcel(){
		let data = [];
		if(this.dadosFiltrados.length == 0){
			this.dadosFiltrados = this.profissionais;
		}
		for(let index in this.dadosFiltrados){
			data[index] = {
				'Condutor' : this.dadosFiltrados[index].profissional_nome,
				'Base/Unidade' : '',
				'Matricula' : '',
				'CNH' : this.dadosFiltrados[index].profissional_cnh,
				'Vencimento CNH' : moment(this.dadosFiltrados[index].profissional_data_vencimento_cnh).format('DD/MM/YYYY'),
				'Tipo CNH' : '',
				'Validade curso socorrista' : '',
				'Colisões' : '',
				'HE' : '',
				'Atestados' : '',
				'Afastamentos' : '',
				'Vacinação em dia' : '',
				'Ferias Data Prevista': '',
				'Ferias Data Venc.': '',
				'Estatuario' : ''
			};
		}
		this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Relatório de condutores');
	}

	
	print(){
		let url = location.href.split('#')[0] + '#' +'(print:print/relatorio/condutores/'+ this.authSvc.getUsuarioId() +')'
		window.open(url);
	}

}
